/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AnalyticsReadView } from '../model';
// @ts-ignore
import { ErrorView } from '../model';
/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Read analytics of given type
     * @param {'overview' | 'property-detail' | 'company-detail'} type Analytics type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsResourceReadAnalytics: async (
      type: 'overview' | 'property-detail' | 'company-detail',
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'type' is not null or undefined
      assertParamExists('analyticsResourceReadAnalytics', 'type', type);
      const localVarPath = `/v1/analytics/{type}`.replace(`{${'type'}}`, encodeURIComponent(String(type)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Read analytics of given type
     * @param {'overview' | 'property-detail' | 'company-detail'} type Analytics type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsResourceReadAnalytics(
      type: 'overview' | 'property-detail' | 'company-detail',
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsReadView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsResourceReadAnalytics(type, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AnalyticsApiFp(configuration);
  return {
    /**
     *
     * @summary Read analytics of given type
     * @param {'overview' | 'property-detail' | 'company-detail'} type Analytics type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsResourceReadAnalytics(
      type: 'overview' | 'property-detail' | 'company-detail',
      options?: any
    ): AxiosPromise<AnalyticsReadView> {
      return localVarFp.analyticsResourceReadAnalytics(type, options).then((request) => request(axios, basePath));
    }
  };
};

/**
 * Request parameters for analyticsResourceReadAnalytics operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiAnalyticsResourceReadAnalyticsRequest
 */
export interface AnalyticsApiAnalyticsResourceReadAnalyticsRequest {
  /**
   * Analytics type
   * @type {'overview' | 'property-detail' | 'company-detail'}
   * @memberof AnalyticsApiAnalyticsResourceReadAnalytics
   */
  readonly type: 'overview' | 'property-detail' | 'company-detail';
}

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
  /**
   *
   * @summary Read analytics of given type
   * @param {AnalyticsApiAnalyticsResourceReadAnalyticsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsApi
   */
  public analyticsResourceReadAnalytics(
    requestParameters: AnalyticsApiAnalyticsResourceReadAnalyticsRequest,
    options?: AxiosRequestConfig
  ) {
    return AnalyticsApiFp(this.configuration)
      .analyticsResourceReadAnalytics(requestParameters.type, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
